/* Fake Fruit — global JS */
(function(){
  // Add to cart from product cards (AJAX)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adicionando...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      btn.textContent = '✓ Adicionado';
      setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 1400);
      // refresh cart count
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var el = document.querySelector('.cart-count');
        if (el) el.textContent = c.item_count;
        else if (c.item_count > 0) {
          var icon = document.querySelector('.icon-btn[aria-label="Carrinho"]');
          if (icon) {
            var span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = c.item_count;
            icon.appendChild(span);
          }
        }
      });
    })
    .catch(function(){
      btn.textContent = 'Erro';
      setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 1400);
    });
  });
})();

/* Scroll reveal */
(function(){
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = '.sec-hd, .trust-item, .pcard, .kit-card, .tcard, .timeline-step, .faces-tag, .faces-title, .faces-text, .faces-feat, .faces-cta, .faces-img, .email-inner, .page-hero-inner, .contact-card, .contact-map-wrap, .pdp-gallery-main, .pdp-buy, .empty-state, .timeline-cta';
  var els = document.querySelectorAll(sel);
  var groups = new Map();
  els.forEach(function(el){
    el.classList.add('ff-reveal');
    var p = el.parentElement;
    var i = groups.get(p) || 0;
    el.style.setProperty('--ffd', Math.min(i * 90, 450) + 'ms');
    groups.set(p, i + 1);
  });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) { en.target.classList.add('ff-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function(el){ io.observe(el); });
})();
